<template>
  <div class="tw-fixed tw-inset-0 tw-z-loading" v-if="show">
    <div
      class="tw-absolute tw-inset-0 tw-bg-mainbg1 tw-opacity-50"
      tw-z-loading
    ></div>
    <div class="tw-absolute tw-inset-0 tw-z-loading">
      <div
        class="tw-flex tw-justify-center tw-items-center tw-h-screen tw-text-primary tw-text-2xl"
      >
        <div class="tw-text-center">
          <div>Loading</div>
          <div
            class="tw-border-r-4 tw-border-t-4 tw-border-solid tw-border-primary tw-rounded-full tw-w-10 tw-h-10 tw-m-auto tw-animate-spin"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import { loadingQueve } from "@/state/appState";

export default defineComponent({
  computed: {
    show() {
      return loadingQueve.value.length > 0;
    },
  },
});
</script>
